module.exports = __webpack_public_path__ + "assets/HandTool.e09570de8ab869bba8ba069eee16ab68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/tools/HandTool.svg
// module id = 873
// module chunks = 1